import React from "react";
import "./styles/style.scss";
import Remove from "./icons/Remove";
import {DatasetAxis} from "./models/types";

type SelectedDatasetElementProps = {
    selectedDataset: DatasetAxis
    removeDataset: (datasetId: string) => void
    dragStart:(e:any, identifier:string) => void
}

const SelectedDatasetElement = ({removeDataset, selectedDataset, dragStart}: SelectedDatasetElementProps) => {
    return <div key={selectedDataset.identifier}
                id={selectedDataset.identifier}
                className={`text selectedDataset`}
                draggable
                onDragStart={(e) => dragStart(e, selectedDataset.identifier)}>
        <span className="text">{selectedDataset.formatedTitle}</span>
        <div className="removeIcon" onClick={() => removeDataset(selectedDataset.identifier)}>
            <Remove width={10} height={10}/>
        </div>
    </div>
};

export default SelectedDatasetElement;
